export const mobileTrayViews = ({ intl }) => ({
  activity: {
    label: intl.formatMessage({
      id: 'shared_components.activity-input.activity-input-header',
      defaultMessage: 'What are you planning?'
    }) },
  location: {
    label: intl.formatMessage({
      id: 'shared_components.location-input.location-input-header',
      defaultMessage: 'Where?'
    }) },
  main: {
    label: intl.formatMessage({
      id: 'shared_components.main-input.main-input-header',
      defaultMessage: 'Find a Space'
    })
  }
});
